import { ReactNode } from 'react';
import BrandMark from '../common/BrandMark';
import styles from './AuthShell.module.css';

interface AuthShellProps {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}

const AuthShell = ({ title, subtitle, children }: AuthShellProps) => (
  <div className={styles.container}>
    <div className={styles.background} />
    <main className={styles.main}>
      <div className={styles.logoSection}>
        <div className={styles.logoIcon}>
          <BrandMark size={52} decorative />
        </div>
        <h1 className="font-headline text-3xl font-bold tracking-tight text-on-surface">Infrio</h1>
      </div>
      <div className={styles.card}>
        <div className="mb-6">
          <h2 className="text-xl font-headline font-semibold text-on-surface">{title}</h2>
          {subtitle && <p className="text-on-surface-variant text-sm mt-1">{subtitle}</p>}
        </div>
        {children}
      </div>
    </main>
  </div>
);

export default AuthShell;
